<template>
	<div class="leadership_team">
		<team-listing-item
			v-for="(team_member, index) in JSON.parse(team)" :key="(index)"
			:staff_name="team_member.staff_name"
			:staff_role="team_member.staff_role"
			:linked_in="team_member.linked_in"
			:email="team_member.email"
			:profile_picture="team_member.profile_picture"
		></team-listing-item>
	</div>
</template>

<script>
import TeamListingItem from '../vue/TeamListingItem.vue';
export default {
	data() {
		return {};
	},

	props: {
		team: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {
		TeamListingItem,
	},

	created() {},
	mounted() {
		console.log(this.team);
	},
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/variables";

.leadership_team {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	row-gap: 2rem;
	column-gap: 2rem;
}

</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/TeamListing.vue